<template>
  <div>
    <section class="section home-image">
      <div class="container">
        <div class="columns">
          <div class="column is-5">
            <img class="m-2" :src="mariologo" alt="Mario Machuca Sanchez Sitio Oficial"/>
            <div class="m-2">
              <nav class="level">
                <p class="level-item has-text-centered">
                  <a class="" href="https://twitter.com/MachucaCROC" target="_blank" title="twitter"><img :src="twitterimg" alt="twitter"/></a>
                </p>
                <p class="level-item has-text-centered">
                  <a class="" href="https://www.facebook.com/mariomachuca.croc" target="_blank" title="facebook"><img :src="facebookimg" alt="Facebook"/></a>
                </p>
                <p class="level-item has-text-centered">
                  <a class="" href="https://www.instagram.com/machucacroc/" target="_blank" title="instagram"><img :src="instagramimg" alt="Instagram"/></a>
                </p>
              </nav>
            </div>
            <router-link to="contacto" class="button is-large is-danger m-2">Contáctame</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="text-letter-spacing-big-1">AL DÍA</h2>

        <div class="columns">
          <div class="column">
            <div class='card-content is-flex is-horizontal-center'>
              <div class="field has-addons">
                <p class="control">
                  <router-link to="noticias" class="button is-large is-danger is-selected">Noticias</router-link>
                </p>
                <p class="control">
                  <router-link to="videos" class="button is-large">Videos</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>


        <div class="columns">
          <div class="column is-8">
            <img :src="'https://api.plataformasocialmedia.pw'+mainNew.images[0].path+'/'+mainNew.images[0].file_name" :alt="mainNew.title"/>

            <div class="card">
              <div class="card-content">
                <router-link :to="{name:'NoticiasPage',params:{slug:mainNew.slug}}">
                  <p class="title">
                    {{ mainNew.title }}
                  </p>
                  <p class="subtitle">
                    Noticias
                  </p>
                </router-link>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="columns" v-for="(n , i) in news">
              <div class="column is-9">
                <h4 class="has-text-grey has-text-left">NOTICIAS</h4>
                <router-link :to="{name:'NoticiasPage',params:{slug:n.slug}}" class="has-text-dark">
                  <p class="has-text-left">{{ n.title }}</p>
                </router-link>
              </div>
              <div class="column is-3">
                <img :src="'https://plataformasocialmedia.pw'+n.images[0].path+'/small/'+n.images[0].file_name" :alt="n.title"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-success">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">
            CONMEMORANDO EL DIA DEL TRABAJO CON LA FAMILIA
          </h1>
          <div class="columns">
            <div class="column">
              <h3 class="title">
              | MARIO MACHUCA
              </h3>
              <p class="has-text-justified has-text-weight-bold">Gracias a cada una de las personas que nos acompañaron en el magno evento de la CROC, al cual llamamos "Conmemorando el Día del Trabajo con la Familia". Este año, contamos con la presencia de Ivonne Montero, Los Compadres y el payaso Chispa, quienes animaron la fiesta desde la conducción. También bailamos y cantamos con Los Siete Latinos y el grupo estelar Super Lamas. Cabe mencionar los shows, los concursos y nuestra tradicional tómbola.</p>
            </div>
            <div class="column">
              <div class="video-container">
                <iframe src="https://www.youtube.com/embed/B3RtRnkIiAY" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-success is-paddingless is-marginless">
      <div class="hero-body is-paddingless is-marginless">
        <div class="columns is-paddingless is-marginless">
          <div class="column is-paddingless is-marginless">
            <img :src="baner1" alt="Informe Legislativo"/>
          </div>
          <div class="column is-paddingless is-marginless">
            <img :src="baner2" alt="Prevención a las adicciones"/>
          </div>
          <div class="column is-paddingless is-marginless">
            <img :src="baner3" alt="Contra el cambio climatico"/>
          </div>
          <div class="column is-paddingless is-marginless">
            <img :src="baner4" alt="Educación"/>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-success">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">
            INFOGRAFÍAS
          </h1>
          <h3 class="title is-size-5">
            CONOCE LOS PROGRAMAS SOCIALES POLÍTICOS Y SINDICALES DE NUESTRA ORGANIZACIÓN.
          </h3>
          <div class="columns">
            <div class="column" v-for="(info,i) in infografias">
              <img :src="info" @click="imageSelected(info)" alt="Infografías CROC"/>
            </div>
          </div>
          <router-link to="infografias" class="button is-large is-danger">Ver todas</router-link>

        </div>
      </div>
    </section>

    <section class="section home-picture is-medium">
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1 class="title is-size-3 has-text-success">
              CONÓCEME
            </h1>
            <p class="has-text-grey">LA GENTE EXIGE HONESTIDAD, TRANSPARENCIA Y PARA ESTAR MEJOR COMUNICADOS TODOS LOS DÍAS COMPARTO MIS ACTIVIDADES EN REDES SOCIALES.</p>
            <div class='card-content is-flex is-horizontal-center'>
              <figure class="image is-128x128">
                <img class="is-rounded" :src="profile">
              </figure>
            </div>
            <h3 class="title is-size-4 has-text-grey">Mario Machuca Sánchez</h3>
          </div>
        </div>
      </div>
    </section>


    <modal v-show="showModal" :imageselected="imageselected" @close="showModal = false"></modal>
  </div>
</template>

<script>
import axios from 'axios';
import mariom from '@/assets/img/Mario.png'
import mariologo from '@/assets/img/mariologo.png'
import facebook from '@/assets/img/facebook.png'
import twitter from '@/assets/img/twitter.png'
import profile from '@/assets/img/profile.jpg'
import instagram from '@/assets/img/instagram.png'
import Modal from '@/components/layouts/partials/modal'

import infografia1 from '@/assets/img/infografias/afiliacion.jpg'
import infografia2 from '@/assets/img/infografias/contracambio.jpg'
import infografia3 from '@/assets/img/infografias/deporte.jpg'
import infografia4 from '@/assets/img/infografias/culturasalud.jpg'

import baner1 from '@/assets/img/baner1.png'
import baner2 from '@/assets/img/baner2.png'
import baner3 from '@/assets/img/baner3.png'
import baner4 from '@/assets/img/baner4.png'

export default {
  name: 'Home',
  data () {
    return {
      news:[],
      mainNew:{
        title:'',
        slug:'null',
        images:[
          {
            file_name:'',
            path:'',
          },
        ]
      },
      mariom:mariom,
      mariologo:mariologo,
      facebookimg:facebook,
      profile:profile,
      twitterimg:twitter,
      instagramimg:instagram,
      showModal: false,
      imageselected:'',
      infografias:[
        infografia1,
        infografia2,
        infografia3,
        infografia4,
      ],
      baner1:baner1,
      baner2:baner2,
      baner3:baner3,
      baner4:baner4,
    }
  },
  computed: {
  },
  components: {
    Modal
  },
  mounted() {
  },
  methods:{
    imageSelected(img){
      this.imageselected=img;
      this.showModal = true;
    },
    init(){
      var self = this;
      axios.post(process.env.API_URL_V1+'news?page=1&api_token='+process.env.API_TOKEN_V1, {type_web:'mariomachuca',limit:7})
      .then(function (response) {
        self.news=response.data.data;
        self.mainNew=response.data.data[0];
        self.news.splice(0,1);
      })
      .catch(function (error) {
      });
    },

  },
  created :function(){
    this.init();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue